import request from '@/axios/index.js'
const lend = '/user/sell/lend/';
export function initLend(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: lend + 'initLend'
    })
}
export function submitForm(data,loading,noFailMsg) {
    return request.axios({
        loading:loading,
        data:data,
        url: lend + 'submitForm',
        noFailMsg,
    })
}
export function mfamount(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: lend + 'mfamount'
    })
}
export function getEstInt(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: lend + 'getEstInt'
    })
}
export function submitFormAll(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: lend + 'submitFormAll'
    })
}
// 融资时，获取资金方列表
export function routeListApi(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: '/fund/route/list'
    })
}
// 融资保存贸易背景
export function finSaveTradeBackground(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: '/account/invoice/saveTradeBackground'
    })
}
// 查询融资协议
export function queryAgreementList(data,loading) {
  return request.axios({
      loading:loading,
      data:data,
      url: '/fnc/agreement/queryAgreementList'
  })
}
// 保存融资协议
export function saveOrUpdateBizLawTxtTrans(data,loading) {
  return request.axios({
      loading:loading,
      data:data,
      url: '/fnc/agreement/saveOrUpdateBizLawTxtTrans'
  })
}
// 删除融资协议
export function deleteLawTxtTrans(data,loading) {
  return request.axios({
      loading:loading,
      data:data,
      url: '/fnc/agreement/deleteLawTxtTrans'
  })
}
// 校验融资申请是否在途业务
export function checkOriGldIsFnsing(data,loading) {
  return request.axios({
      loading:loading,
      data:data,
      url: '/user/sell/lend/checkOriGldIsFnsing'
  })
}
// 融资银行准入申请
export function bankBuildingApi(bankCd,id) {
  return request.axios({
      type:"get",
      url: `/bankBuilding/${bankCd}/${id}`
  })
}
// 获取线上的相关协议
export function getFncLawText(data) {
  return request.axios({
      type: "post",
      data: data,
      url: `/fnc/agreement/getFncLawText/${data.bankCd}/${data.fncJrnlId}`
  })
}



// WEBPACK FOOTER //
// ./src/api/sell.js